export default {
  methods: {
    parseText (text) {
      return text
        .replace(/~~(.*)~~/, '<span class="normal-case">$1</span>')
        .replace(/ + /g, ' <span class="t-light">+</span> ')
    }
  }
}
